module.exports = __webpack_public_path__ + "static/knittedheart-4b830a866f28880cba3bcf49dd9d703d.jpeg";